import { FaCheck } from "react-icons/fa";

const ThankYou = () => {
    return (
        <div className="container">
            <nav className="container text-center">
                <img
                    className="img-fluid"
                    src="images/logo.svg"
                    alt="pegasus chauffeur"
                    style={{ width: "25rem", paddingTop: "5rem" }}
                />
            </nav>

            <div
                className="row justify-content-center align-items-center"
                style={{ height: "77vh" }}
            >
                <div
                    className="col-10 col-sm-9 col-md-8 col-lg-6 justify-items-center p-5"
                    style={{
                        borderRadius: "20px",
                        // background: "rgba(255, 255, 255, 0.025)",
                        background: "white",
                        // backdropFilter: "blur(20px)",
                        border: "1px solid rgba(182, 139, 71, 0.5)",
                        // boxShadow: "20px 20px 20px rgba(182, 139, 71, 0.2)",
                    }}
                >
                    <div className="text-center">
                        <span
                            className="bigTick d-inline-block"
                            style={{
                                fontSize: "50px",
                                // color: "#b68b47",
                            }}
                        >
                            <FaCheck />
                        </span>
                        <h1
                            className="my-3"
                            // style={{
                            //     fontSize: "140px",
                            //     fontWeight: "600",
                            //     fontFamily: "The Nautigal",
                            // }}
                        >
                            Thank You
                        </h1>
                        <p>
                            for choosing us for your Chauffeur needs. We have
                            received your booking request. Our team will get in
                            touch with you soon ...
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThankYou;
